export default "__VITE_ASSET__BhB4w7WV__ 120w, __VITE_ASSET__BifZ00ik__ 240w, __VITE_ASSET__B7Bltan2__ 480w, __VITE_ASSET__CjJmTM2Y__ 512w";